import React, { createContext, useState, useEffect } from "react";
import { UserLoginData } from "../../components/common/charts/Enums";

interface PermissionContextType {
  permissions: Record<string, number>;
  refreshPermissions: () => void;
}

const PermissionContext = createContext<PermissionContextType | null>(null);

const PermissionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [permissions, setPermissions] = useState<Record<string, number>>({});

  const refreshPermissions = () => {
    const storedPermissions = sessionStorage.getItem(UserLoginData.permissions);
    if (storedPermissions) {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (e) {
        console.error("Failed to parse permissions from sessionStorage", e);
      }
    } else {
      setPermissions({});
    }
  };

  useEffect(() => {
    refreshPermissions();
  }, []);

  const values = {
    permissions,
    refreshPermissions,
  };

  return (
    <PermissionContext.Provider value={values}>
      {children}
    </PermissionContext.Provider>
  );
};

export { PermissionProvider, PermissionContext };
